import styled from 'styled-components';

export const Spacer = styled.div`
  height: ${(props) => (props.vertical ? props.height || '20px' : '0px')};
  width: ${(props) => (props.horizontal ? props.width || '20px' : '0px')};
`;

export const RootContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  min-height: calc(100vh - 115px);
  box-sizing: border-box;
  padding: 29px;
  height: ${(props) => (props.loading ? 'calc(100vh - 115px)' : 'auto')};
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const DivHeader = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const NormalText = styled.div`
  font-size: ${(props) => props.fontSize || '12px'};
  color: ${(props) => props.color || '#000000'};
  font-family: Source Sans Pro, IBM Plex Sans, sans-serif;
`;

export const BoldText = styled.p`
  font-size: ${(props) => props.fontSize || '12px'};
  font-weight: bold;
  font-family: Source Sans Pro, IBM Plex Sans, sans-serif;
`;

export const Row = styled.div`
  display: flex;
  gap: 15px;
`;
